export default function getReactionResourceData(
    reactionType: string,
    isAnimated: boolean
): any | null {
    let animationData = null;
    try {
        const fileExtension = isAnimated ? '.json' : '.svg';
        animationData = require('../resources/' + reactionType + fileExtension);
    } catch (e) {}

    return animationData;
}
